import DragItem from "../../ddTxtImg/model/DragItem";
import CompareItemModel from "./CompareItemModel"
import CompareKeyModel from "./CompareKeyModel"
import DropItemModel from "./DropItemModel";

class CompareContainerModel {
  constructor() {
    this.compareItemContainerId = 0;
    this.compareItemList = [];
    this.compareKeyList = [];
    this.dropItemList = [];

    this.styleIndex = 0;
    this.initStyleArr()
    this.selectedStyle = this.styleArr[this.styleIndex]

  }

  initStyleArr = () => {
    this.styleArr = [
      [{ class: "border-change content-bg-change", style: { borderWidth: "0px", borderStyle: "solid", borderColor: "black" } }],
      [{ class: "border-change content-bg-change", style: { borderWidth: "1px", borderStyle: "solid", borderColor: "black" } }],
      [{ class: "border-change content-bg-change", style: { borderWidth: "2px", borderStyle: "solid", borderColor: "black" } }],
      [{ class: "border-change content-bg-change", style: { borderWidth: "3px", borderStyle: "solid", borderColor: "black" } }],

    ]
  }

  nextStyle = () => {

    if (this.styleIndex < this.styleArr.length - 1) {
      this.styleIndex++;
      this.selectedStyle = this.styleArr[this.styleIndex]
    }
  }

  prevStyle = () => {
    if (this.styleIndex > 0) {
      this.styleIndex--;
      this.selectedStyle = this.styleArr[this.styleIndex]
    }
  }

  addCompareItem = () => {
    let compareItem = new CompareItemModel();
    compareItem.compareItemName = "Column name";
    compareItem.compareItemIndex = this.compareItemList.length
    this.compareItemList.push(compareItem);


    for (let i = 0; i < this.compareKeyList.length; i++) {
      let dropItem = new DropItemModel()
      this.dropItemList[i].push(dropItem)
    }
  }


  addKeyItem = () => {
    let keyItem = new CompareKeyModel();
    keyItem.compareKeyName = "row name";
    keyItem.compareKeyIndex = this.compareKeyList.length;
    this.compareKeyList.push(keyItem);

    this.dropItemList.push([]);

    for (let i = 0; i < this.compareItemList.length; i++) {
      let dropItem = new DropItemModel()
      this.dropItemList[this.dropItemList.length - 1].push(dropItem)
    }
  }


  getAsJson = () => {
    let obj = {}
    obj.compareItemContainerId = this.compareItemContainerId;
    obj.selectedStyle = this.selectedStyle
    obj.compareItemList = []
    for (let i = 0; i < this.compareItemList.length; i++) {
      let item = new CompareItemModel()
      item = this.compareItemList[i].getAsJson()
      obj.compareItemList.push(item)
    }

    obj.compareKeyList = []
    for (let i = 0; i < this.compareKeyList.length; i++) {
      let item = new CompareKeyModel()
      item = this.compareKeyList[i].getAsJson()
      obj.compareKeyList.push(item)
    }

    obj.dropItemList = []
    for (let i = 0; i < this.dropItemList.length; i++) {
      obj.dropItemList[i] = []
      for (let j = 0; j < this.dropItemList[i].length; j++) {
        obj.dropItemList[i].push(this.dropItemList[i][j].getAsJson())
      }
      // let item = new DropItemModel()
      // item=this.dropItemList[i].getAsJson()
      // obj.dropItemList.push(item)
    }

    return obj
  }

  initFromJson = (obj) => {

    this.compareItemContainerId = obj.compareItemContainerId;
    this.selectedStyle = obj.selectedStyle
    for (let i = 0; i < obj.compareItemList.length; i++) {
      let item = new CompareItemModel()
      item.initFromJson(obj.compareItemList[i])
      this.compareItemList.push(item)
    }
    for (let i = 0; i < obj.compareKeyList.length; i++) {
      let item = new CompareKeyModel()
      item.initFromJson(obj.compareKeyList[i])
      this.compareKeyList.push(item)
    }
    for (let i = 0; i < obj.dropItemList.length; i++) {
      this.dropItemList[i] = []
      for (let j = 0; j < obj.dropItemList[i].length; j++) {
        let item = new DropItemModel()
        item.initFromJson(obj.dropItemList[i][j])
        this.dropItemList[i].push(item)
      }



    }

    // this.styleIndex=obj.styleIndex
    // this.selectedStyle=this.styleArr[this.styleIndex]
  }

  deleteCompareItem = (obj) => {
    //delete column
    this.compareItemList = this.compareItemList.filter(function (item, index) {
      if (obj.compareItemIndex != item.compareItemIndex)
        return item;
    })

    //delete drop item
    this.dropItemList.forEach(list => {
      list.splice(obj.compareItemIndex, 1)
    });

    //reorder indexes
    var compareItemIndex = 0;
    this.compareItemList.forEach(element => {
      element.compareItemIndex = compareItemIndex;
      compareItemIndex++;
    });
  }

  deleteCompareKey = (obj) => {
    //delete row
    this.compareKeyList = this.compareKeyList.filter(function (Key, index) {
      if (obj.compareKeyIndex != Key.compareKeyIndex)
        return Key;
    })

    //delete drop items
    this.dropItemList.splice(obj.compareKeyIndex, 1)

    //reorder indexes
    var compareKeyIndex = 0;
    this.compareKeyList.forEach(element => {
      element.compareKeyIndex = compareKeyIndex;
      compareKeyIndex++;
    });

    // var dropIndex = 0;
    // this.dropItemList.forEach(list => {
    //   list.forEach(element => {
    //     element.compareKeyIndex = compareKeyIndex;
    //     compareKeyIndex++;
    //   })
    // });
  }

  switchUpKeys = (obj) => {

    const index = obj.compareKeyIndex;
    if (index != 0) {
      let rowList1 = this.dropItemList[index - 1]
      let rowList2 = this.dropItemList[index]

      this.dropItemList[index - 1] = rowList2;
      this.dropItemList[index] = rowList1;

      let key1 = this.compareKeyList[index - 1]
      key1.compareKeyIndex++

      let key2 = this.compareKeyList[index]
      key2.compareKeyIndex--

      this.compareKeyList[index - 1] = key2
      this.compareKeyList[index] = key1
    }
  }

  switchDownKeys = (obj) => {
    const index = obj.compareKeyIndex;

    if (index != this.compareKeyList.length - 1) {
      let rowList1 = this.dropItemList[index]
      let rowList2 = this.dropItemList[index + 1]

      this.dropItemList[index] = rowList2;
      this.dropItemList[index + 1] = rowList1;

      let key1 = this.compareKeyList[index]
      key1.compareKeyIndex++

      let key2 = this.compareKeyList[index + 1]
      key2.compareKeyIndex--

      this.compareKeyList[index] = key2
      this.compareKeyList[index + 1] = key1
    }
  }

  switchUpItem = (obj) => {

    const index = obj.compareItemIndex;
    if (index != 0) {

      this.dropItemList.forEach(list => {
        let dropItem1 = list[index - 1]
        let dropItem2 = list[index]

        list[index - 1] = dropItem2;
        list[index] = dropItem1;

      });

      let Item1 = this.compareItemList[index - 1]
      Item1.compareItemIndex++

      let Item2 = this.compareItemList[index]
      Item2.compareItemIndex--


      this.compareItemList[index - 1] = Item2
      this.compareItemList[index] = Item1
    }
  }

  switchDownItem = (obj) => {
    const index = obj.compareItemIndex;

    if (index != this.compareItemList.length - 1) {

      this.dropItemList.forEach(list => {
        let dropItem1 = list[index]
        let dropItem2 = list[index + 1]

        list[index] = dropItem2;
        list[index + 1] = dropItem1;
      })


      let Item1 = this.compareItemList[index]
      Item1.compareItemIndex++

      let Item2 = this.compareItemList[index + 1]
      Item2.compareItemIndex--

      this.compareItemList[index] = Item2
      this.compareItemList[index + 1] = Item1
    }
  }

  initFromJsonTest4You = (obj, dragItemList) => {

    let question = obj.question
    let answerMapping = obj.answerMapping

    let questionObj = JSON.parse(question);
    let AnswerObj = JSON.parse(answerMapping);

    let list = questionObj.list
    let columnA = list.columnA
    //let columnB = list.columnB

    this.compareItemList = []
    this.compareKeyList = []

    for (var key of Object.keys(columnA)) {
      let compareKeyModel = new CompareKeyModel()
      compareKeyModel.compareKeyIndex = parseInt(key) - 1
      compareKeyModel.compareKeyName = columnA[key].replace('###', '')

      this.compareKeyList.push(compareKeyModel)
    }

    let compareItem = new CompareItemModel();
    compareItem.compareItemName = "";
    compareItem.compareItemIndex = this.compareItemList.length
    this.compareItemList.push(compareItem);



    for (let i = 0; i < this.compareKeyList.length; i++) {
      let dropItem = new DropItemModel()
      this.dropItemList.push([]);
      this.dropItemList[i].push(dropItem)
    }

    for (var key of Object.keys(AnswerObj)) {
      let answers = AnswerObj[key]
      let source = answers[0]
      let target = answers[1]

      for (var sourceKey of Object.keys(source)) {
        for (var targetKey of Object.keys(target)) {
          if (this.dropItemList[parseInt(sourceKey) - 1] && dragItemList[parseInt(targetKey) - 1])
            this.dropItemList[parseInt(sourceKey) - 1][0].dragList.push(dragItemList[parseInt(targetKey) - 1])
        }
      }

      // let compareItemModel = new CompareItemModel();
      // for (var answerKey of Object.keys(source)) {
      //   if (answerKey - 1 < this.compareItemList.length) {
      //     compareItemModel = this.compareItemList[parseInt(answerKey) - 1]
      //   }
      // }

      // let compareKeyModel = new CompareKeyModel()
      // for (var answerKey of Object.keys(target)) {
      //   if (answerKey - 1 < this.compareKeyModel.length) {
      //     compareKeyModel = this.compareKeyList[parseInt(answerKey) - 1]
      //     compareKeyModel.compareKeyList.push(compareKeyModel)
      //   }

      // }
    }
  }
}
export default CompareContainerModel
